import {
  BULB_GLOW_EFFECT,
  HAND_WITH_BULB_IMAGE,
} from "../../constants/imageConstants";
import GlowEffect from "../common/GlowEffect";
import { useServicesData } from "../../hooks/useServicesData";

export default function ServicesHeroSection() {
  const { data } = useServicesData();

  return (
    <section className="relative px-5 pt-10 sm:px-10 md:px-16 min-h-[50vh] flex">
      <GlowEffect />
      <div className="grid md:grid-cols-2 gap-8 lg:gap-16 justify-center overflow-y-hidden">
        {/* Left Content */}
        <div className="space-y-6 lg:space-y-14 z-1">
          <h1 className="text-4xl md:text-6xl xl:text-9xl font-bold leading-tight text-white tracking-wide w-1/2">
            <span className="bg-gradient-to-r from-white to-white/80 bg-clip-text text-transparent drop-shadow-[0px_4px_10px_rgba(255,255,255,0.25)]">
              {data.heroSection.title}
            </span>
          </h1>

          <p className="text-lg lg:text-xl text-[#d9d9d9] leading-relaxed max-w-2xl px-4 border-l-2">
            {data.heroSection.description}
          </p>
        </div>

        {/* Right Content - 3D Graphics */}
        <div className="relative top-[14px] md:top-16 lg:top-11 xl:top-10 2xl:top-8 3xl:top-16 flex justify-center items-center order-last -z-10">
          {/* Hand with Bulb */}
          <div className="relative flex justify-center items-center">
            <img
              src={HAND_WITH_BULB_IMAGE}
              alt="Hand holding lightbulb"
              className="w-[300px] md:w-[400px] lg:w-[800px] h-auto animate-float -z-2"
            />

            {/* Bulb Glow Effect - positioned specifically on the bulb area */}
            <div className="absolute top-1/4 left-[44%] transform -translate-x-1/2 -translate-y-1/2 -z-10">
              <img
                src={BULB_GLOW_EFFECT}
                alt="Bulb glow effect"
                className="w-48 md:w-56 lg:w-64 xl:w-72 h-auto opacity-95"
                style={{
                  filter: "blur(2px)",
                  transform: "scale(1.5)",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
